
// Simple logger utility to standardize log formats and levels

// Log levels
export type LogLevel = 'info' | 'warn' | 'error' | 'debug';

// Set this to false to disable debug logs, changed from true
const DEBUG_ENABLED = false;

export interface Logger {
  info: (message: string, ...args: any[]) => void;
  warn: (message: string, ...args: any[]) => void;
  error: (message: string, ...args: any[]) => void;
  debug: (message: string, ...args: any[]) => void;
}

export const createLogger = (moduleName: string): Logger => {
  const prefix = `[${moduleName}]`;
  
  return {
    info: (message: string, ...args: any[]) => {
      // Only log important info messages in production, but always log notification-related messages
      if (!import.meta.env.PROD || 
          message.includes('error') || 
          message.includes('failed') || 
          message.includes('notification') ||
          message.includes('Sending') ||
          message.includes('sent successfully')) {
        console.info(`${prefix} ${message}`, ...args);
      }
    },
    warn: (message: string, ...args: any[]) => {
      console.warn(`${prefix} ${message}`, ...args);
    },
    error: (message: string, ...args: any[]) => {
      console.error(`${prefix} ${message}`, ...args);
    },
    debug: (message: string, ...args: any[]) => {
      // Only log debug messages in development mode and if debug is enabled
      if (import.meta.env.DEV && DEBUG_ENABLED) {
        console.debug(`${prefix} ${message}`, ...args);
      }
    }
  };
};
